<template>
	<div>
		<myheader headTitle="消息中心"></myheader>
		<div class="all_main">
			<div id="list" class="all_list_content_nopadding">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div style="min-height: 80vh;height: auto;">
						<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div class="messageItem" v-for="(item, index) in list" :key="index"
								@click="goDetails(item)">
								<div class="title">
									<!-- :style="{visibility:item.isRead?'visible':'hidden'}" -->
									<span class="dian" style="visibility:hidden;">{{" "}}</span>
									<span class="text14 textcolorblack font_weight_bold">{{ item.messageName }}</span>
									<span class="text12 textcolor999"
										style="position: absolute;right: .5rem;top: .3rem;">{{Tool.dateFormate(item.messageTime,'yyyy-MM-dd hh:mm')}}</span>
								</div>
								<div class="message_content text12 textcolor999">{{ item.messageData }}
								</div>
								<!-- <p class="horizontal_line"></p>
								<div class="all_height_line18 text12 textcolorblack all_text_center">查看详情</div> -->
							</div>
						</van-list>
						<van-empty style="margin-top: 20vh;" description="暂无数据" v-show="list.length==0" />
					</div>
				</van-pull-refresh>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,
		PullRefresh,
		List
	} from "vant";
	import {
		getBanner
	} from '../../utils/shareRequest'
	export default {
		name: "newslist",
		components: {
			[Empty.name]: Empty,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
		},
		data() {
			return {
				//消息列表
				list: [],
				//加载下一页
				loading: false,
				//加载是否完成
				finished: false,
				//是否刷新
				refreshing: false,
				//每页数量
				pageSize: 10,
				//页数
				pageNum: 0,
				//滑动高度
				scrollTop: 0,
				//滑动列表
				listView: null,
				//消息总数
				total: 0,
			};
		},
		activated() {
			//console.log('newslist-activated', this.scrollTop)
			if (this.scrollTop != 0) {
				this.listView.scrollTop = this.scrollTop
			}
		},
		deactivated() {
			//console.log('newslist-deactivated')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			//console.log("el-beforeRouteLeave", to, from);
			if (to.meta.index > from.meta.index) {
				if (from.meta.keepAlive) {
					this.$store.commit('addKeepAlive', from.name);
				}
			} else {
				if (from.meta.keepAlive) {
					this.$store.commit('removeKeepAlive', from.name);
				}
			}
			//console.log(this.$store.state.keepAlive)
			next();
		},
		mounted() {
			this.init()
			this.onRefresh()
		},
		methods: {
			//初始化
			init() {
				this.listView = document.getElementById('list')
				this.listView.addEventListener("scroll", (e) => {
					//记录位置
					this.scrollTop = this.listView.scrollTop
				});
			},
			//获取列表
			getList() {
				this.$post("/my/api/getReadMessages", {
					pageParams: {
						current: this.pageNum,
						desc: true,
						orderBy: "",
						size: this.pageSize
					}
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.list = this.list.concat(res.data.records);
						this.loading = false;
						if (this.list.length >= res.data.total) {
							this.finished = true;
						}
					} else {
						this.$Toast(res.message || '网络异常！');
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('queryNotices', err)
					//this.$Toast(res.message || '网络异常！');
				})
			},
			// 下拉刷新
			onRefresh() {
				this.$store.dispatch(this.$LoadShow, true)
				//this.refreshing = true
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.pageNum = 0
				this.onLoad();
			},
			// 上拉加载
			onLoad() {
				// 清空列表数据
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.pageNum++
				this.getList()
			},
			//查看详情
			goDetails(item) {
				return
				this.$router.push({
					path: "/newsDetails",
					query: {
						id: item.notificationId,
						type: '0',
					},
				});
			},
		},
	};
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";

	.selectedFlag {
		color: #02a7f0;
		background-color: white;
		border: 1px solid #02a7f0;
	}

	.noselectedFlag {
		color: #7f7f7f;
		background-color: #d7d7d7;
		border: none;
	}


	.messageItem {
		background-color: white;
		border-radius: .3rem;
		margin: .5rem;
		padding: .3rem .5rem;

		.title {
			position: relative;

			.dian {
				line-height: 1.4rem;
				font-size: .6rem;
				// color: red;
				color: #333;
				margin-right: .2rem;
			}

		}

		.message_content {
			margin-top: .2rem;
			padding: 0 .2rem;
			padding-bottom: .5rem;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box; //将div1转换为盒子模型
			// -webkit-line-clamp: 2; //设置div1的文本为2行
			-webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
		}
	}
</style>